import { Box, Button } from "@mui/material/";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Container } from "@mui/system";
import { useAppDispatch, useAppSelector } from "app/hooks";
import Header from "components/header/Header";
import { MediumText } from "components/typography";
import { patchAgent, selectAgentUsersListTotal } from "features/agent/agentSlice";
import { selectPageAgentUsersList, selectRowsPerPageAgentUsersList } from "features/table/tableSlice";
import { selectUserRole } from "features/user/userSlice";
import { UserRoles } from "interfaces/UserRoles";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import LotOfferButton from "../lotOffer/LotOfferButton";
import AgentInformation from "./AgentInformation";
import AgentMasterData from "./AgentMasterData";
import AgentOptions from "./AgentOptions";
import AgentUsers from "./AgentUsers";
import CountyInformation from "./CountyInformation";
import styles from "./LotOffer.module.css";

export default function AdminAgent() {

  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const saveChanges = () => {
    const promises = [];
    promises.push(dispatch(patchAgent()));
    Promise.all(promises).then((result) => {
      // navigate("/admin/agentenliste");
      setChangesSaved(true);
    });
  };
  const [changesSaved, setChangesSaved] = useState(false);
  const userRole = useAppSelector(selectUserRole);
  const agentListTotal = useAppSelector(selectAgentUsersListTotal);
  const page = useAppSelector(selectPageAgentUsersList)
  const rowsPerPage = useAppSelector(selectRowsPerPageAgentUsersList)
  
  const isAdmin = useMemo(() => {
    return userRole === UserRoles.Admin
  }, [userRole]);

  return (
    <>
      <Container
        maxWidth="xl"
        sx={{
          pt: 4,
          pb: 4,
          // ml: 4,
          pl: { lg: 12, md: 14, xs: 13 },
        }}
      >
        <Header backButton={isAdmin} header="Agent" />
        <Box
          sx={{
            mt: 3,
          }}
        >
          <div className={styles.LotOfferContainer}>
            <Grid2 container className={` ${styles.sdsd}`}>
              <AgentMasterData className={styles.LotOfferMasterData} />
              <AgentInformation className={styles.LotOfferMasterData} />
              <CountyInformation className={styles.LotOfferMasterData} />
              <AgentOptions error={error} setError={setError} className={styles.LotOfferMasterData} />
            </Grid2>
          </div>
        </Box>

        {changesSaved && (
          <Box sx={{ mt: 2 }}>
            <MediumText fWeight="bold" color="#072D26">
              Änderungen wurden gespeichert.
            </MediumText>
          </Box>
        )}
        <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
          <LotOfferButton
            label="Änderungen speichern"
            sx={{ borderRadius: "26px", height: "51px", fontWeight: "bold" }}
            onClick={saveChanges}
            disabled={error.length > 0}
          />

          <Button
            style={{
              borderRadius: "26px",
              color: "#072D26",
              fontWeight: "bold",
              border: "2px solid #C0D904",
            }}
            className={`${styles.roundInputs} ${styles.sizeInputs}`}
            variant="outlined"
            onClick={() => {
              if(userRole === UserRoles.Admin) {
                navigate("/admin/agentenliste") 
              } else {
                navigate("/agent/losliste") 
              }
            }}
          >
            Änderungen VERWERFEN
          </Button>
        </Box>
        {isAdmin ? <AgentUsers page={page} rowsPerPage={rowsPerPage} agentListTotal={agentListTotal} /> : null}
      </Container>
    </>
  );
}
